<!--
  Copyright (C) 2020 ExploRêve

  This program is free software: you can redistribute it and/or modify
  it under the terms of the GNU Affero General Public License as
  published by the Free Software Foundation, either version 3 of the
  License, or (at your option) any later version.

  This program is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Affero General Public License for more details.

  You should have received a copy of the GNU Affero General Public License
  along with this program.  If not, see <https://www.gnu.org/licenses/>.

  Full source code is available at <https://gitlab.com/exploreve/frontend>.
-->

<template>
  <div class="scout-marin">
    <div v-show="step == 1">
      <div class="row">
        <div class="col-md-2"></div>
        <div class="col-md-5">
          <div class="right">
            <p>
              Salut les ami·es, qu’est-ce qui vous amène ici ?<br />
              Vous cherchez une ancre ? Et vous vous êtes dis que les scouts marins, c’était bonne pioche !
            </p>
            <div class="arrowright"></div>
          </div>
          <div class="right">
            <p>
              Ben effectivement, bonne pioche : on doit avoir une ancre plate de rab. Je ne sais pas si c’est adapté
              pour un ballon, mais ça peut toujours vous dépanner. Par contre, elle est sur notre camp, qui est sur
              l'île là-bas.
            </p>
            <div class="arrowright"></div>
          </div>
          <div class="right">
            <p>
              Je peux vous prêter la barque pour traverser, mais il faut attendre le signal "passez" avant de larguer
              les amarres. On communique en sémaphore pour éviter les abordages. Vous savez lire du sémaphore, dites ?
              Bravo, ça fait plaisir. Alors bon vent !
            </p>
            <div class="arrowright"></div>
          </div>

          <div class="object" v-on:click="step += 1">Relever le défi</div>
        </div>
        <div class="col-md-1"></div>
        <div class="col-md-4">
          <img class="marin" src="https://cdn.exploreve.fr/content/cluedo/Marins.svg" height="400px" />
        </div>
      </div>
    </div>
    <div v-show="step == 2">
      <div class="row">
        <div class="col-md-6">
          <div class="right">
            <p>
              <img
                src="https://cdn.exploreve.fr/content/cluedo/semaphore.jpeg"
                class="img-fluid ${3|rounded-top,rounded-right,rounded-bottom,rounded-left,rounded-circle,|}"
                alt="lsf"
              />
            </p>
          </div>
          <div>
            <div class="right col-12">
              <div class="arrowleft"></div>
              <p class="row">
                <input
                  type="text"
                  class="form-control col-6 offset-1"
                  id="message"
                  placeholder="Ecris le numéro du bon message"
                  size="50"
                />
                <button class="btn btn-secondary col-4 mx-2" v-on:click="verify()">Valider</button>
              </p>
            </div>
          </div>
          <div class="right" id="badResponse">
            <p class="text-danger h5">Mauvaise réponse ! Réessaye</p>
            <div class="arrowright"></div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="right">
            <p>
              Lequel de ces messages vous indique que vous pouvez traverser ?
            </p>
            <div class="arrowbot-message" style="top: 57px;"></div>
          </div>
          <div style="position: absolute; top: 120px; left: 100px;">
            <img class="marin" src="https://cdn.exploreve.fr/content/cluedo/Marins.svg" height="400px" />
          </div>
        </div>
      </div>
    </div>
    <div v-show="step == 3">
      <div class="row">
        <div class="col-md-8" id="foundResponse">
          <div style="margin: auto; text-align: center;">
            <img src="https://cdn.exploreve.fr/content/cluedo/Ancre.svg" alt="ancre" height="500px" />
          </div>
          <!-- <div>
            <button @click="getAncre()" class="btn btn-secondary btn-lg mx-auto col">Récupérer l' ancre</button>
          </div> -->
          <div class="object" @click="getAncre()">
            Récupérer l'ancre
          </div>
        </div>
        <div class="col-md-4">
          <div class="right-message" style="top: 10px;">
            <p>
              Voila une ancre que nous pouvons te donner ! Elle n’est pas vraiment faite pour les ballons-songes mais ça
              devrait faire l’affaire !
            </p>
            <div class="arrowbot-message" style="top: 100px;"></div>
          </div>
          <div style="position: absolute; top: 150px;">
            <img class="marin" src="https://cdn.exploreve.fr/content/cluedo/Marins.svg" height="400px" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.marin {
  z-index: 2;
  position: relative;
}

.left,
.right-message {
  font-family: "Faune";
  display: table;
  background-color: white;
  max-width: 500px;
  width: intrinsic;
  width: -moz-max-content;
  width: -webkit-max-content;
}

.right-message {
  padding: 10px;
  max-width: 350px;
  border-radius: 5px;
  margin-right: 100px;
}

.arrowleft {
  position: relative;
  content: "";
  left: -20px;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-right: 20px solid white;
  z-index: 5;
}

.arrowright {
  position: relative;
  content: "";
  left: 20px;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;

  border-left: 20px solid white;
}

.arrowbot-message {
  content: "";
  width: 0px;
  height: 0px;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-top: 20px solid white;
  position: relative;
  top: 100px;
  left: -250px;
}

#badResponse {
  display: none;
}
</style>
<script>
export default {
  name: "Marins",
  data: function () {
    return {
      found: false,
      step: 1
    };
  },
  mounted() {
    this.$emit("audio", { action: "play", id: "musicmarins" });
  },
  props: {},
  methods: {
    verify() {
      if (
        document.getElementById("message").value == "3" ||
        document.getElementById("message").value.toLowerCase() == "trois" ||
        document.getElementById("message").value.toLowerCase() == "message 3" ||
        document.getElementById("message").value.toLowerCase() == "message trois"
      ) {
        this.found = true;
        this.step += 1;
      } else {
        document.getElementById("badResponse").style.display = "flex";
      }
    },
    getAncre() {
      this.$emit("recupObject", "ancre");
      this.$emit("closeModal");
      this.$emit("audio", { action: "play", id: "musiccluedo" });
    }
  },
  components: {}
};
</script>
